"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _each = _interopRequireDefault(require("lodash/each"));

//   { "id": 1, "parentId": null, "obj": "Germany" },
//   { "id": 2, "parentId": null, "obj": "USA" },
//
//   { "id": 3, "parentId": 1, "obj": "BMW" },
//   { "id": 4, "parentId": 1, "obj": "Mercedes" },
//
//   { "id": 5, "parentId": 2, "obj": "Tesla" },
//
//   { "id": 6, "parentId": 3, "obj": "i3" },
//   { "id": 7, "parentId": 3, "obj": "i8" },
//   { "id": 8, "parentId": 4, "obj": "S-Class" },
//
//   { "id": 9, "parentId": 5, "obj": "Model S" }
//
var Hierarchy =
/*#__PURE__*/
function () {
  function Hierarchy(items) {
    (0, _classCallCheck2.default)(this, Hierarchy);
    (0, _defineProperty2.default)(this, "noParentId", -1);
    this.clear();

    if (items) {
      this.add(items);
    }
  }

  (0, _createClass2.default)(Hierarchy, [{
    key: "clear",
    value: function clear() {
      this._items = {};
      this._itemsByParent = {};
    }
  }, {
    key: "_toParentId",
    value: function _toParentId(parentId) {
      return parentId ? parentId : this.noParentId;
    }
  }, {
    key: "_addItem",
    value: function _addItem(item) {
      this._items[item.id] = item;

      var parentId = this._toParentId(item.parentId);

      if (!this._itemsByParent[parentId]) {
        this._itemsByParent[parentId] = [];
      }

      this._itemsByParent[parentId].push(item);
    }
  }, {
    key: "add",
    value: function add(items) {
      var _this = this;

      if (!Array.isArray(items)) {
        items = [items];
      }

      items.forEach(function (item) {
        return _this._addItem(item);
      });
    }
  }, {
    key: "get",
    value: function get(id) {
      return this._items[id];
    }
  }, {
    key: "eachByParent",
    value: function eachByParent(parentId, onItem) {
      // Use each() so that we can return false to exit loop prematurely
      parentId = this._toParentId(parentId);
      (0, _each.default)(this._itemsByParent[parentId], onItem);
    }
  }, {
    key: "mapByParent",
    value: function mapByParent(parentId, onItem) {
      parentId = this._toParentId(parentId);
      var items = this._itemsByParent[parentId];

      if (items) {
        return items.map(onItem);
      } else {
        return [];
      }
    }
  }]);
  return Hierarchy;
}();

exports.default = Hierarchy;